import React, { useCallback } from 'react';
import { ComponentWrapper } from '../../helperComponents/componentWrapper/ComponentWrapper';
import sharedStyles from './Shared/styles';
import { View } from 'react-native';
import { Header } from './Shared/Header';
import { AdminScreenProps } from '../../../typesAndInterfaces/componentProps';
import { MiniGamesList, MiniGameView } from './components/miniGame';

const MiniGames = ({ route, navigation }: AdminScreenProps<'MiniGames'>) => {

  const addNewButtonAction = useCallback(() => {
    navigation.setParams({ setNumber: 'new' });
  }, [navigation]);

  return (
    <ComponentWrapper
      innerContainerStyle={sharedStyles.innerContainer}
      containerStyle={sharedStyles.container}
      scrollViewStyle={sharedStyles.scrollView}
      wrapInScrollView
    >
      <Header />
      <View style={sharedStyles.body}>
        {route?.params?.setNumber ? (
          <MiniGameView setNumber={route.params.setNumber} />
        ) : (
          <MiniGamesList addNewButtonAction={addNewButtonAction} />
        )}
      </View>
    </ComponentWrapper>
  );

};

export { MiniGames };
